import SvgIcon from './svg-icon'
export default SvgIcon



// WEBPACK FOOTER //
// ./src/components/svg-icon/index.js